
import Vue from "vue";

export default Vue.extend({
  name: "BtnExcluir",
  components: {},
  props: {
    showIcon: {
      type: Boolean,
      default: true,
    },
    text:{
      type: String,
      default: "Borrar",
    },
    titleConfirm:{
      type: String,
      default: "Confirmación",
    },
    textConfirm:{
      type: String,
      default: "Va borrar los datos, ¿desea continuar?"
    },
    textBtnOK:{
      type: String,
      default: "OK"
    },
    textBtnCancel:{
      type: String,
      default: "Cancelar"
    },
    color:{
      type: String,
      default: "danger",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      dialog: false as boolean,
    };
  },
  methods: {
    excluir(): void {
      this.dialog = false;
      this.$emit("excluir");
    },
  },
});
